<template>
  <div class="agent-account-page">
    <!-- 头部筛选区 -->
    <van-sticky :offset-top="safeAreaTop" :z-index="99">
      <van-tabs v-model="active" class="wx-tabs">
        <van-tab title="提现申请">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" pulling-text="下拉刷新"
            loosing-text="释放刷新">
            <van-empty v-if="!listLoading && list.length === 0" image="search" description="暂无提现记录" />
            <!-- 列表区域 -->
            <div class="list-container" v-else>
              <van-list v-model="listLoading" :finished="listFinished" finished-text="没有更多了" @load="onLoad">
                <div v-for="item in list" :key="item.id" class="bill-card">
                  <div class="bill-header">
                    <div class="arrival-info">
                      <div class="arrival-content">
                        <div class="arrival-amount">
                          <span class="currency">¥</span>
                          <span class="num">{{ item.withdrawalAmount ?? '0.00' }}</span>
                        </div>
                        <span class="arrival-label">{{ item.createTime }}</span>
                      </div>
                    </div>
                    <van-tag :type="getStatusType(item.isConfirm)" round size="medium" class="status-badge">
                      {{ getStatusText(item.isConfirm) }}
                    </van-tag>
                  </div>

                  <div class="deduction-bill">
                    <div class="bill-title-row">
                      <van-icon name="balance-pay" size="12" />
                      <span>余额扣减明细</span>
                    </div>
                    <div class="bill-body">
                      <div class="bill-row">
                        <span class="row-label">提现本金</span>
                        <span class="row-value deduct">-¥{{ item.withdrawalAmount ?? '0.00' }}</span>
                      </div>
                      <div class="bill-row main-fee" @click="toggleFeeDetail(item.id)">
                        <div class="label-wrap">
                          <span class="row-label">成本合计</span>
                          <van-icon :name="expandedIds.includes(item.id) ? 'arrow-down' : 'arrow'" size="12"
                            color="#c8c9cc" />
                        </div>
                        <span class="row-value deduct">-¥{{ (item.serviceFee+item.taxFee) ?? '0.00' }}</span>
                      </div>
                      <div v-show="expandedIds.includes(item.id)" class="sub-detail">
                        <div class="bill-row sub">
                          <span class="row-label">手续费</span>
                          <span class="row-value deduct">-¥{{ item.serviceFee ?? '0.00' }}</span>
                        </div>
                        <div class="bill-row sub">
                          <span class="row-label">
                            个税
                            <van-icon name="info-o" size="10" color="#c8c9cc" @click.stop="showTaxTip" />
                          </span>
                          <span class="row-value deduct">-¥{{ item.taxFee ?? '0.00' }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="bill-footer">
                      <span class="footer-label">本次共扣除</span>
                      <span class="footer-value">-¥{{ item.totalAmount ?? '0.00' }}</span>
                    </div>
                  </div>

                  <!-- <div class="bill-meta">
                  <div class="meta-item">
                    <van-icon name="bank-o" size="12" />
                    <span>{{ formatCardNo(item.bankAccount) }}</span>
                  </div>
                  <div class="meta-item time">
                    <van-icon name="clock-o" size="12" />
                    <span>{{ item.createTime }}</span>
                  </div>
                </div> -->
                </div>
              </van-list>
            </div>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="提现账户">
          <div class="header-bar">
            <div class="header-title">申请账户</div>
            <div class="header-actions">
              <van-button size="small" plain @click="openBindPopup" class="bind-btn">
                <van-icon name="plus" />新增绑定

              </van-button>
            </div>
          </div>
          <van-pull-refresh v-model="refreshingBid" @refresh="onBindRefresh" success-text="刷新成功" pulling-text="下拉刷新"
            loosing-text="释放刷新">
            <BindHisCard :account-list="accountList"/>

          </van-pull-refresh>
        </van-tab>
      </van-tabs>

    </van-sticky>

    <!-- 绑定弹窗 -->
    <van-popup v-model="showBindPopup" position="bottom" round
      :style="{ minHeight: '98vh',maxHeight: '100vh', paddingBottom: 'env(safe-area-inset-bottom)' }">
      <div class="bind-popup">
        <div class="popup-nav">
          <span class="nav-title">申请绑定卡</span>
          <!-- <van-icon name="cross" class="nav-close"/> -->
          <span class="nav-close" @click="showBindPopup = false">关闭</span>
        </div>
        <van-form ref="bindForm" @submit="onBindSubmit" class="bind-form">
          <div class="form-group">
            <YeeBankSelect :value="bindForm.bankCode" :bank-list="customBankList" label="开户银行" required
              placeholder="选择开户银行" @change="onBankChange" />
          </div>
          <div class="form-group">
            <div class="group-title"><span class="required-star">*</span>收款账号</div>
            <van-field v-model="bindForm.bankAccount" type="tel" maxlength="23" placeholder="请输入银行卡号"
              :formatter="formatBankCard" :rules="[
                { required: true },
                { validator: validateBankCard, trigger: 'blur', message: '银行卡号格式不正确' }
              ]" />
          </div>
          <div class="form-group">
            <div class="group-title"><span class="required-star">*</span>预留手机</div>
            <van-field v-model="bindForm.mobile" type="tel" maxlength="11" placeholder="需与银行预留一致"
              :formatter="(val) => val.replace(/\s/g, '')" :rules="[
                { required: true},
                { validator: validateMobile, trigger: 'blur', message: '手机号格式不正确' }
              ]" />
          </div>
          <div class="form-group">
            <div class="group-title"><span class="required-star">*</span>身份证件</div>
            <div class="id-upload-area">
              <van-uploader v-model="idCardImage.imageFront" :max-count="1" :after-read="(f) => afterReadId(f, 'front')"
                accept="image/*">
                <div class="upload-slot">
                  <template v-if="!idCardImage.imageFront.length">
                    <van-icon name="photograph" size="24" color="#c8c9cc" />
                    <span>上传人像面</span>
                  </template>
                  <img v-else :src="idCardImage.imageFront[0] && idCardImage.imageFront[0].url" class="preview"
                    alt="人像面" />
                </div>
              </van-uploader>
              <van-uploader v-model="idCardImage.imageBack" :max-count="1" :after-read="(f) => afterReadId(f, 'back')"
                accept="image/*">
                <div class="upload-slot">
                  <template v-if="!idCardImage.imageBack.length">
                    <van-icon name="photograph" size="24" color="#c8c9cc" />
                    <span>上传国徽面</span>
                  </template>
                  <img v-else :src="idCardImage.imageBack[0] && idCardImage.imageBack[0].url" class="preview"
                    alt="国徽面" />
                </div>
              </van-uploader>
            </div>
            <div class="idCard-item">
              <div class="form-group">
                <div class="group-title"><span class="required-star">*</span>姓 名</div>
                <van-field v-model="bindForm.realName" type="text" maxlength="30" placeholder="请输入真实姓名"
                  :formatter="(val) => val.replace(/\s/g, '')" :rules="[
                    { required: true },
                    { validator: validateRealName, message: '姓名格式不正确，仅支持汉字、字母和间隔符' }
                  ]" />
              </div>
              <div class="form-group">
                <div class="group-title"><span class="required-star">*</span>证件号码</div>
                <van-field v-model="bindForm.idCard" type="text" maxlength="18" placeholder="请输入身份证号"
                  :formatter="(val) => val.replace(/\s/g, '').toUpperCase()" :rules="[
                    { required: true},
                    { validator: validateIdCard, message: '身份证号格式不正确' }
                  ]" />
              </div>
            </div>
          </div>
          <div class="form-action">
            <van-button round block type="primary" native-type="submit" :loading="bindLoading" loading-text="提交中...">
              确认申请
            </van-button>
            <van-button type="default" size="large" native-type="button" class="cancel-btn"
              @click="showBindPopup = false">取消</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <van-popup v-model="showBankPicker" position="bottom" round>
      <van-picker show-toolbar title="选择开户银行" :columns="bankList" @confirm="onBankConfirm"
        @cancel="showBankPicker = false" />
    </van-popup>
    <van-popup v-model="showDatePicker" position="bottom" round>
      <van-datetime-picker type="date" title="选择日期" :max-date="maxDate" @confirm="onDateConfirm"
        @cancel="showDatePicker = false" v-model="currentDate" />
    </van-popup>
  </div>
</template>

<script>
import BindHisCard from '@/components/BindHisCard'
import YeeBankSelect from '@/components/YeeBankSelect'
import customBankList from '@/components/YeeBankcode.json'
import {
  withdrawalHistory,
  withdrawalAccount,
  uploadIdCard,
  addAccount
} from '@/api/withdrawal.js'

const TAX_TIP_MESSAGE = '提现金额按9%预扣个税（平台代扣）'
const PAGE_SIZE = 20

const BANK_LIST = [
  '中国工商银行', '中国农业银行', '中国银行', '中国建设银行',
  '交通银行', '招商银行', '中国邮政储蓄银行', '中信银行'
]

export default {
  components: {
    YeeBankSelect,
    BindHisCard
  },
  data () {
    return {
      active: this.$route.query?.active || 0,
      customBankList,
      pagination: {
        page: 0,
        limit: PAGE_SIZE,
        endDate: ''
      },
      showDatePicker: false,
      maxDate: new Date(),
      currentDate: new Date(),

      listLoading: false,
      listFinished: false,
      listRefreshing: false,
      refreshing: false,
      refreshingBid: false,

      list: [],
      accountList: [],
      accountColumns: [],
      expandedIds: [],
      bankList: BANK_LIST, // ✅ 挂载到 data 供模板使用

      showBindPopup: false,
      bindLoading: false,
      showBankPicker: false,
      // ✅ 修复6: 补全绑定表单所有字段，避免 v-model 警告
      bindForm: {
        bankCode: '',
        bankName: '',
        bankAccount: '',
        mobile: '',
        realName: '',
        idCard: '',
        imageFront: '',
        imageBack: '',
        idBack: []
      },
      idCardImage: {
        imageFront: [],
        imageBack: []
      }
    }
  },

  computed: {
    safeAreaTop () {
      const val = getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-top')
      return parseInt(val) || 0
    }
  },

  mounted () {
    this.onLoad()
    this.getAccountList()
  },

  methods: {
    onBankChange (bankItem) {
      this.bindForm.bankCode = bankItem.bankType
      this.bindForm.bankName = bankItem.bankName // 单独存储名称用于展示/提交
      console.log(this.bindForm)
    },
    onRefresh () {
      this.pagination.page = 1
      this.listFinished = false
      this.onLoad(true)
    },
    onBindRefresh () {
      this.listFinished = false
      this.getAccountList()
    },
    onLoad (isRefresh = false) {
      if (this.listFinished) return
      this.listLoading = true
      this.fetchWithdrawalList(isRefresh)
    },

    fetchWithdrawalList (isRefresh) {
      const userId = (this.$store.state.userID || '').split('a')[0]

      if (!userId || !/^\d+$/.test(userId)) {
        this.handleListError('用户身份异常，请重新登录')
        return
      }

      withdrawalHistory({
        token: this.$store.state.token,
        userId,
        iccid: '',
        page: this.pagination.page,
        limit: this.pagination.limit
      })
        .then(res => {
          const rows = res.data?.extend?.rows || []
          if (isRefresh) {
            this.list = rows
            this.refreshing = false
          } else {
            this.list = [...this.list, ...rows]
          }

          if (rows.length < this.pagination.limit) {
            this.listFinished = true
          } else {
            this.pagination.page += this.pagination.limit
          }
        })
        .catch(err => {
          console.error('[Withdrawal History Error]', err)
          this.$toast(err.response?.data?.msg || '加载失败，下拉可重试')
        })
        .finally(() => {
          this.listLoading = false
          this.listRefreshing = false
        })
    },

    resetList () {
      this.list = []
      this.expandedIds = []
      this.pagination.page = 0
      this.listFinished = false
      this.listLoading = false

      this.$nextTick(() => {
        this.onLoad()
      })
    },

    handleListError (msg) {
      this.$toast(msg)
      this.listLoading = false
      this.listFinished = true
      this.listRefreshing = false
    },

    async getAccountList () {
      try {
        const userId = (this.$store.state.userID || '').split('a')[0]
        if (!userId) return

        const {
          data: response
        } = await withdrawalAccount({
          token: this.$store.state.token,
          userId
        })
        this.accountList = response.extend.rows || []
      } catch (e) {
        console.error('[Account List Error]', e)
      }
      this.refreshingBid = false
    },

    toggleFeeDetail (id) {
      const idx = this.expandedIds.indexOf(id)
      if (idx > -1) {
        this.expandedIds.splice(idx, 1)
      } else {
        this.expandedIds.push(id)
      }
    },

    showTaxTip () {
      this.$dialog.alert({
        title: '成本说明',
        message: TAX_TIP_MESSAGE,
        confirmButtonText: '我知道了'
      })
    },

    onDateConfirm (value) {
      const d = new Date(value)
      this.pagination.endDate =
          `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
      this.showDatePicker = false
      this.resetList()
    },

    getStatusType (s) {
      return {
        0: 'warning',
        1: 'success',
        2: 'danger'
      }[s] || 'default'
    },
    getStatusText (s) {
      return {
        0: '审核中',
        1: '已通过',
        2: '已驳回'
      }[s] || '未知'
    },
    formatCardNo (no) {
      return no ? `尾号${no.slice(-4)}` : '--'
    },

    openBindPopup () {
      this.showBindPopup = true
      this.$nextTick(() => {
        this.$refs.bindForm && this.$refs.bindForm.resetValidation()
      })
    },

    formatBankCard (val) {
      return val.replace(/\s/g, '').replace(/(.{4})/g, '$1 ').trim()
    },
    validateMobile (val) {
      if (!val) return false

      // 去除空格，兼容复制粘贴格式
      const mobile = val.replace(/\s/g, '')

      // 中国大陆手机号：1开头 + 第二位为3-9 + 后续9位数字
      // 覆盖移动/联通/电信/广电全部已分配号段
      return /^1[3-9]\d{9}$/.test(mobile)
    },
    validateRealName (val) {
      if (!val) return false
      // 预处理：去空格（与 formatter 保持一致，防止粘贴时带入空格）
      const name = val.replace(/\s/g, '')
      // 长度校验：2~30个字符
      if (name.length < 2 || name.length > 30) return false
      // 字符集校验：仅允许汉字、大小写字母、间隔符(·)、连字符(-)
      // \u4e00-\u9fa5 覆盖 CJK 统一汉字基本区
      // \u00b7 是中文间隔符（少数民族姓名常用）
      // \u2022 是部分输入法输出的圆点（兼容处理）
      const reg = /^[\u4e00-\u9fa5a-zA-Z\u00b7\u2022-]+$/
      return reg.test(name)
    },
    validateBankCard (val) {
      if (!val) return false
      // 去除所有空格和横杠，兼容各种复制格式
      const cleaned = val.replace(/[\s-]/g, '')
      // 13~22位纯数字（覆盖主流借记卡+信用卡+对公户）
      return /^\d{13,22}$/.test(cleaned)
    },
    validateIdCard (val) {
      if (!val) return false

      // 预处理：去空格、统一大写
      const id = val.replace(/\s/g, '').toUpperCase()

      // 1. 基础格式：17位数字 + 数字/X
      if (!/^\d{17}[\dX]$/.test(id)) return false

      // 2. 校验出生日期是否合法（排除 2026-07-09 之后的日期）
      const year = parseInt(id.substring(6, 10), 10)
      const month = parseInt(id.substring(10, 12), 10)
      const day = parseInt(id.substring(12, 14), 10)
      const birthDate = new Date(year, month - 1, day)
      const today = new Date('2026-07-09') // ← 使用当前系统时间

      // 日期无效 或 未来出生
      if (
        birthDate.getFullYear() !== year ||
          birthDate.getMonth() !== month - 1 ||
          birthDate.getDate() !== day ||
          birthDate > today
      ) {
        return false
      }

      // 3. ISO 7064:1983 校验位算法（比 Luhn 更准确）
      const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']

      let sum = 0
      for (let i = 0; i < 17; i++) {
        sum += parseInt(id[i], 10) * weights[i]
      }

      return checkCodes[sum % 11] === id[17]
    },
    onBankConfirm (value) {
      this.bindForm.bankName = value
      this.showBankPicker = false
    },

    // afterReadId (file, side) {
    //   file.status = 'uploading'
    //   setTimeout(() => {
    //     file.status = 'done'
    //     file.url = `https://via.placeholder.com/120x160?text=${side === 'front' ? '人像' : '国徽'}`
    //   }, 1000)
    // },
    async afterReadId (file, side) {
      const userId = (this.$store.state.userID || '').split('a')[0]
      if (!userId) return

      // 1. 设置上传中状态
      file.status = 'uploading'
      file.message = '上传中...'

      try {
        // 2. 构建 FormData（与 Layui upload.render 底层行为一致）
        const formData = new FormData()
        formData.append('file', file.file) // Vant after-read 回调中原始 File 对象在 file.file 中

        // 如果后端需要额外的业务参数（如区分正反面），可在此追加：
        // formData.append('side', side);

        // 3. 发起真实上传请求
        // const res = await fetch(INIT_UPLOAD_URL, {
        //   method: 'POST',
        //   body: formData,
        //   // ⚠️ 注意：使用 FormData 时不要手动设置 Content-Type，浏览器会自动添加 boundary
        // });
        formData.append('token', this.$store.state.token)
        formData.append('userId', userId)
        const {
          data
        } = await uploadIdCard(formData)

        // 4. 校验响应（对齐 Layui 中的 res.code === 0 && res.extend.url 逻辑）
        if (data.code === 0 && data.extend && data.extend.url) {
          file.status = 'done'
          file.message = ''
          // 将后端返回的真实 URL 赋值给 url 属性，供模板中 <img :src="...url"> 渲染
          file.url = data.extend.url
          this.bindForm[side === 'front' ? 'imageFront' : 'imageBack'] = file.url
        } else {
          throw new Error(data.msg || '上传失败')
        }
      } catch (err) {
        // 5. 异常处理
        file.status = 'failed'
        file.message = err.message || '上传异常，请重试'
        console.error(`身份证${side}面上传失败:`, err)
      }
    },

    async onBindSubmit () {
      const userId = (this.$store.state.userID || '').split('a')[0]
      if (!userId) return
      if (!this.bindForm.imageFront.length || !this.bindForm.imageBack.length) {
        this.$toast('请上传完整身份证照片')
        return
      }
      this.bindLoading = true
      try {
        const {
          data: response
        } = await addAccount({
          token: this.$store.state.token,
          userId,
          ...this.bindForm
        })
        if (response.code === 0) {
          this.$toast.success('已提交申请')
          this.showBindPopup = false
          this.refreshingBid = true
          this.getAccountList()
        } else {
          throw new Error(response.msg || '申请失败')
        }
      } catch (error) {
        this.$toast(error.message)
      } finally {
        this.bindLoading = false
      }
    }
  }
}
</script>

<style scoped>
  .agent-account-page {
    min-height: 100vh;
    background: #f5f7fa;
    font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif;
    color: #323233;
    padding-bottom: env(safe-area-inset-bottom);
  }

  .header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #fff;
  }

  .header-bar .header-actions {
    display: flex;
    align-items: center;
    /* ✅ 关键！让按钮垂直居中，不拉伸 */
    justify-content: space-between;
    margin-right: 15px;
  }

  .header-title {
    font-size: 24px;
    font-weight: 500;
    color: #c1c3c5;
  }

  .filter-btn,
  .bind-btn {
    height: 30px;
    line-height: 28px;
    padding: 22px 5px 22px 5px;
    font-size: 24px;
    font-weight: 550;
    border-radius: 15px;
    border: none;
  }

  .filter-btn {
    background: #f7f8fa;
    color: #1989fa;
  }

  .bind-btn {
    background: #ecf5ff;
    color: #1989fa;
    margin: 0 2px 0 8px;
  }

  .list-container {
    padding: 12px 12px 16px;
  }

  .bill-card {
    background: #fff;
    border-radius: 13px;
    padding: 0 16px 8px 16px;
    margin: 0 15px 15px 15px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);
  }

  .bill-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 14px;
  }

  /* 1. 外层容器：移除固定高度和居中，改为自适应 */
  .arrival-info {
    display: inline-flex;
    align-items: flex-start;
    /* 关键：改为顶部对齐 */
    line-height: 1;
    /* 删除 height: 28px; 让内容自然撑开，避免截断 */
  }

  /* 2. 新增内容包装器：控制内部垂直排列 */
  .arrival-content {
    display: flex;
    flex-direction: column;
    /* 金额在上，时间在下 */
    align-items: flex-start;
  }

  /* 3. 时间标签：移除 display:block，改用 margin 控制间距 */
  .arrival-label {
    line-height: 1.2;
    /* 必须！12px 文字在 lh:1 下易被切 */
    font-size: 12px;
    color: #969799;
    margin-top: 4px;
  }

  /* 4. 金额样式：完全保留原版，不做任何修改 */
  .arrival-amount {
    color: #07c160;
    font-weight: 700;
    line-height: 1;
  }

  .arrival-amount .currency {
    font-size: 14px;
    margin-right: 2px;
  }

  .arrival-amount .num {
    font-size: 24px;
    letter-spacing: -0.5px;
  }

  .status-badge {
    padding: 4px 10px;
    font-size: 12px;
    font-weight: 500;
  }

  .bill-header>.status-badge {
    align-self: flex-end;
    /* 关键！让右侧标签底部对齐容器底部 */
  }

  .deduction-bill {
    background: #fafbfc;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 12px;
  }

  .bill-title-row {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #969799;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .bill-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
    font-size: 13px;
  }

  .row-label {
    color: #646566;
  }

  .row-value.deduct {
    color: #323233;
    font-weight: 500;
    font-family: "Menlo", "Monaco", monospace;
    font-size: 13px;
  }

  .main-fee {
    cursor: pointer;
  }

  .label-wrap {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .sub-detail {
    padding-left: 16px;
    border-left: 2px solid #ebedf0;
    margin-left: 4px;
    margin-top: 4px;
  }

  .sub-detail .bill-row.sub {
    padding: 3px 0;
  }

  .sub-detail .row-label {
    font-size: 12px;
    color: #969799;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .sub-detail .row-value {
    font-size: 12px;
    color: #969799;
  }

  .bill-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px dashed #ebedf0;
  }

  .footer-label {
    font-size: 13px;
    font-weight: 600;
    color: #323233;
  }

  .footer-value {
    font-size: 14px;
    font-weight: 700;
    color: #ff7d00;
    font-family: "Menlo", "Monaco", monospace;
  }

  .bill-meta {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #969799;
  }

  .meta-item {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .bind-popup {
    padding: 0 0 env(safe-area-inset-bottom);
  }

  .popup-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #f5f7fa;
  }

  .nav-title {
    font-size: 17px;
    font-weight: 600;
  }

  .nav-close {
    font-size: 26px;
    color: #c8c9cc;
    padding: 4px;
  }

  .bind-form {
    padding: 16px 35px 20px 35px;
  }

  .form-group {
    margin-bottom: 20px;
  }

  .group-title {

    display: block;
    font-size: 18px;
    color: #333;
    margin-bottom: 8px;
  }

  .required-star {
    color: #e53935;
    margin-right: 2px;
  }

  .form-group /deep/ .van-cell {
    background: #f7f8fa;
    border-radius: 8px;
    margin-bottom: 8px;
    padding: 0 16px;
  }

  .form-group /deep/ .van-field__control {
    height: 48px;
    font-size: 20px;
  }

  ::v-deep .van-uploader__input-wrapper {
    width: 100%;
  }

  .id-upload-area {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 8px;
  }

  .upload-slot {
    width: 100%;
    height: 100px;
    background: #f7f8fa;
    border: 1px dashed #dcdee0;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 12px;
    color: #969799;
    overflow: hidden;
  }

  .upload-slot .preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .form-action {
    padding-top: 35px;
  }

  .form-action /deep/ .van-button {
    height: 52px;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
    /* ✅ 锁定验证过的黄金尺寸 */
    height: 75px !important;
    font-size: 32px !important;
    font-weight: 600 !important;
    letter-spacing: 1px;

    /* ✅ 形态与居中（消除扁平感 + 跨系统兼容） */
    border-radius: 16px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    line-height: 1 !important;

    /* ✅ 底部安全区全版本兼容 */
    margin-bottom: calc(24px + env(safe-area-inset-bottom));
    padding-bottom: constant(safe-area-inset-bottom);
    /* iOS < 11.2 兜底 */
  }

  .cancel-btn {
    width: 100%;
    height: 65px;
    border: none;
    border-radius: 30px;
    background: #f0f0f0;
    color: #969799;
    font-size: 32px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;
  }

  .idCard-item {
    padding: 15px;
    border-radius: 5px;
    background: #fcfcfc;
    font-size: 32px;
    font-weight: 500;
  }

  .wx-tabs :deep(.van-tabs__line) {
    background-color: #1989fa !important;
  }
</style>
